import CardNumberInput from "./CardNumberInput";
import CardExpiryInput from "./CardExpiryInput";
import CardCvcInput from "./CardCvcInput";

const stripeComponents = {
  CardNumberInput,
  CardExpiryInput,
  CardCvcInput
}

export default stripeComponents